<template>
   <div class="header">{{ headerValue }}</div>
</template>

<script>
export default{
  name: "PageHeader",
  props: {
    headerTitle: String
  },
  computed: {
    headerValue() {
      return this.headerTitle
    }
  }
}
</script>
